import { React, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axiosapi from "../api/axiosapi";
import 'katex/dist/katex.min.css';
import { InlineMath } from 'react-katex';

const splitContent = (sentence) => {
    const InlineMathRegex = /<InlineMath[^>]*>(.*?)<\/InlineMath>/g;
    const matches = sentence.matchAll(InlineMathRegex);
    let lastIndex = 0;
    const contentArray = [];
  
    for (const match of matches) {
        const InlineMathContent = <InlineMath key={lastIndex} math={match[1]} />;
        const restOfContent = sentence.substring(lastIndex, match.index);
    
        contentArray.push(restOfContent, InlineMathContent);
        lastIndex = match.index + match[0].length;
    }
  
    if (lastIndex < sentence.length) {
        contentArray.push(sentence.substring(lastIndex));
    }
  
    return <div>{contentArray}</div>;
};

const LevelProblemList = () => {
       const {levelURL} = useParams();
       const [ListInLevel, setListInLevel] = useState([]);
       const [level, setLevel] = useState();

       useEffect(() => {
              const urlSetting = () => {
                     let firstChar = levelURL?.[0];
                     let firstNum = Number(firstChar);
                     let secondChar = levelURL?.[5];
                     let secondNum = Number(secondChar);
                     let thirdChar = levelURL?.[10];
                     let thirdNum = Number(thirdChar)+10;
                     let fourthChar = levelURL?.[15];
                     let fifthChar = levelURL?.[16];
                     let fifthNum = Number(fifthChar)+10;
                     let combined = (levelURL?.[firstNum] ?? "0") + (levelURL?.[secondNum] ?? "0") + (levelURL?.[thirdNum] ?? "0") + (levelURL?.[15] ?? "0") + (levelURL?.[fifthNum] ?? "0");
                     setLevel(combined);
              }
              urlSetting();
       }, [levelURL]);

       useEffect(() => {
              const fetchProblemLevelList = async () => {
                     try {
                            const response = await axiosapi.get('/difficultylevel/', {
                                   params: {
                                          url: level
                                   },
                                   withCredentials: true
                            });
                            response.data && setListInLevel(response.data);
                     } catch (error) {
                            console.log(error);
                     }
              }
              fetchProblemLevelList();
       }, [level]);

       return (
              <div className="App-full-container">
                     <div className="App-full-row-container-1">
                            <div className="content-box-1">
                                   <div className="vertical-flex-container-1">
                                          <div style={{textAlign:"left"}}>
                                                 {ListInLevel && ListInLevel.map(prob => {
                                                        return (
                                                               <div key={prob.problemCode}>
                                                                      <Link
                                                                             to={`/problem/level/problem/${prob.problemOrder}`}
                                                                             state={{
                                                                                    "ListInLevel": ListInLevel,
                                                                                    "levelURL": levelURL,
                                                                                    "problemCode": prob.problemCode,
                                                                                    "problemOrder": prob.problemOrder
                                                                             }}
                                                                      >
                                                                             <h6 style={{paddingTop: "25px", paddingRight:"10px", textAlign:"left", color:"black", fontWeight:"bolder", fontSize:"21px"}}>{prob.problemTitle && splitContent(prob.problemTitle)}</h6>
                                                                      </Link>
                                                                      <p style={{paddingTop: "5px", paddingLeft: "5px", paddingRight:"10px", textAlign:"left", color:"black"}}>{prob.problemDescription && splitContent(prob.problemDescription)}</p>
                                                               </div>
                                                        )
                                                 })}
                                          </div>
                                   </div>
                            </div>
                     </div>
              </div>
       );
}

export default LevelProblemList;